import { useEffect } from "react";
import { LegalLayout, LegalSection } from "./LegalLayout";
import { CONTACT } from "../data/content";

export const Datenschutz = () => {
    useEffect(() => {
        document.title = "Datenschutzerklärung | Julians Gartenservice";
    }, []);

    return (
        <LegalLayout title="Datenschutzerklärung" eyebrow="Rechtliches" testid="datenschutz-page">
            <LegalSection title="1. Verantwortlicher">
                <p>
                    Julian Kosinski, Julian&rsquo;s Gartenservice, Sankt-Georg-Garten 6/3,
                    29221 Celle, Deutschland
                    <br />
                    Telefon: {CONTACT.phoneDisplay} · E-Mail: {CONTACT.email}
                </p>
            </LegalSection>

            <LegalSection title="2. Kontaktformular und Anfragen">
                <p>
                    Wenn Sie mir über das Anfrageformular schreiben, verarbeite ich die von Ihnen
                    angegebenen Daten (Name, Telefonnummer bzw. E-Mail-Adresse, gewählte Leistung,
                    Ort/PLZ, Beschreibungstext sowie optional hochgeladene Fotos) ausschließlich
                    zur Bearbeitung Ihrer Anfrage und zur Erstellung eines Angebots.
                </p>
                <p>
                    Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen).
                    Ihre Anfrage wird per E-Mail an mein Postfach übermittelt; hochgeladene Fotos
                    werden auf dem Server dieser Website gespeichert. Nach abschließender
                    Bearbeitung werden die Daten gelöscht, sofern keine gesetzlichen
                    Aufbewahrungspflichten bestehen.
                </p>
            </LegalSection>

            <LegalSection title="3. Hosting und Server-Logdateien">
                <p>
                    Diese Website wird bei einem Hosting-Anbieter betrieben. Beim Aufruf der Seite
                    werden technisch notwendige Verbindungsdaten (z. B. IP-Adresse, Datum und
                    Uhrzeit, aufgerufene Seite) verarbeitet, um die Website auszuliefern und deren
                    Sicherheit zu gewährleisten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO
                    (berechtigtes Interesse am sicheren Betrieb).
                </p>
            </LegalSection>

            <LegalSection title="4. Externe Inhalte und Schriftarten">
                <p>
                    Für die Darstellung werden Schriftarten von Google Fonts (Google Ireland
                    Limited) sowie einzelne Bilddateien von externen Bildservern geladen. Dabei
                    wird Ihre IP-Adresse an den jeweiligen Anbieter übertragen. Rechtsgrundlage
                    ist Art. 6 Abs. 1 lit. f DSGVO (einheitliche, ansprechende Darstellung).
                </p>
            </LegalSection>

            <LegalSection title="5. Cookies und Tracking">
                <p>
                    Diese Website verwendet keine Analyse- oder Marketing-Cookies und keine
                    Tracking-Werkzeuge.
                </p>
            </LegalSection>

            <LegalSection title="6. Ihre Rechte">
                <p>
                    Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung
                    der Verarbeitung Ihrer personenbezogenen Daten sowie auf Datenübertragbarkeit
                    und Widerspruch. Eine erteilte Einwilligung können Sie jederzeit mit Wirkung
                    für die Zukunft widerrufen.
                </p>
                <p>
                    Zudem haben Sie das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu
                    beschweren, z. B. bei der Landesbeauftragten für den Datenschutz
                    Niedersachsen.
                </p>
            </LegalSection>

            <p className="text-sm text-fog">Stand: September 2026</p>
        </LegalLayout>
    );
};
